import { render, staticRenderFns } from "./MapToRelated.vue?vue&type=template&id=02ccd1e5&"
import script from "./MapToRelated.vue?vue&type=script&lang=js&"
export * from "./MapToRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports